import { createAction } from '@reduxjs/toolkit';

export const requestViewAllClassifications = createAction('product/viewAllClassifications');
export const requestViewAllCategories = createAction('product/viewAllCategories');
export const requestViewAllTypes = createAction('product/viewAllTypes');
export const requestViewMetricUnits = createAction('product/viewMetricUnits');
export const requestViewAllMetricUnits = createAction('product/viewAllMetricUnits');
export const requestCreateProductListing = createAction('product/createProductListing');
export const requestCopyListing = createAction('product/copyListing');
export const requestViewPersonProductListings = createAction('product/viewAllProductListings');
export const requestViewProductListing = createAction('product/viewProductListing');
export const requestUpdateProductListing = createAction('product/updateProductListing');
export const requestCreateBuyerListing = createAction('product/createBuyerListing');
export const requestViewPersonBuyerListings = createAction('product/viewBuyerListings');
export const requestViewBuyerListing = createAction('product/viewBuyerListing');
export const requestUpdateBuyerListing = createAction('product/updateBuyerListing');
export const requestCreateSpecification = createAction('product/createSpecification');
export const requestViewAllSpecifications = createAction('product/viewAllSpecifications');
export const requestUpdateClassification = createAction('product/updateClassification');
export const requestUpdateCategory = createAction('product/updateCategory');
export const requestUpdateType = createAction('product/updateType');
export const requestViewAllTypesRegistration = createAction('product/viewAllTypesRegistration');
export const requestBookmarkProductListing = createAction('product/bookmarkProduct');
export const requestViewMarketProductListings = createAction('product/viewAllMarketProductListings');
export const requestViewMarketBuyerListings = createAction('product/viewAllMarketBuyerListings');
export const requestViewDashboard = createAction('product/viewDashboard');
